export default __webpack_public_path__ + "static/media/books2-afterA-480w.4f84a1dc.avif";